import {
  HiddenForPermission,
  MobileTableConteiner,
  PaginationMobile,
  SkeletonMobile,
  TableMobileButton,
  TableMobileCell,
  TableMobileContent,
  TableMobileItem,
  TableMobileTitle
} from '../../../../../../components';
import { goToEditSectors } from '../../../../../../router/coordinator';

export function MobileTable({ sectors, navigate, loading, count, page, offset, handlePage }) {
  const sectorsList = sectors?.map((sector) => {
    return (
      <TableMobileCell key={sector.uuid}>
        <TableMobileItem>
          <TableMobileTitle>Nome </TableMobileTitle>
          <TableMobileContent>{sector.title && sector.title.toTitleCase()}</TableMobileContent>
        </TableMobileItem>

        <TableMobileItem>
          <TableMobileTitle>Sigla </TableMobileTitle>
          <TableMobileContent>{sector.acronym && sector.acronym.toUpperCase()}</TableMobileContent>
        </TableMobileItem>

        <HiddenForPermission keys="EDIT_SECTORS">
          <TableMobileButton onClick={() => goToEditSectors(navigate, sector.uuid)}>
            Editar
          </TableMobileButton>
        </HiddenForPermission>
      </TableMobileCell>
    );
  });

  return (
    <MobileTableConteiner>
      {!loading ? sectorsList : <SkeletonMobile numbersOfColumns={10} />}
      <PaginationMobile count={count} page={page} rowsPerPage={offset} handlePage={handlePage} />
    </MobileTableConteiner>
  );
}
